export const SET_ORDER_TO_EDIT = 'orders/SET_ORDER_TO_EDIT';
export const SET_ROWS_PER_PAGE = 'orders/SET_ROWS_PER_PAGE';
export const SET_PAGE = 'orders/SET_PAGE';

const initialState = {
  orderToEdit: null,
  rowsPerPage: 10,
  page: 0
}

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_ORDER_TO_EDIT:
      return {
        ...state,
        orderToEdit: action.payload,
      }
    case SET_ROWS_PER_PAGE:
        return {
            ...state,
            rowsPerPage: action.payload,
        }
    case SET_PAGE:
        return {
            ...state,
            page: action.payload,
        }

    default:
      return state
  }
}

const setData = (actionName, payload) => {
    return dispatch => {
        dispatch({ 
            type: actionName, 
            payload: payload
        });
    }
}

export const setOrderToEdit = (product) => setData(SET_ORDER_TO_EDIT, product);
export const setRowsPerPageState = (rowsPerPage) => setData(SET_ROWS_PER_PAGE, rowsPerPage);
export const setPageState = (page) => setData(SET_PAGE, page);


